import { z } from 'zod';

export const CoreIntegrationDataSyncMappingScalarFieldEnumSchema = z.enum(['id','cityId','integrationId','createdAt','updatedAt','syncType','gogovFieldName','gogovFieldId','externalFieldName','externalFieldId','mergeField','externalRecordType']);

export default CoreIntegrationDataSyncMappingScalarFieldEnumSchema;
